import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function RelatedTopics({ topics, currentId }: { topics: Topic[]; currentId: string }) {
  const related = topics.filter((t) => t.id !== currentId).slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-secondary-600">
              <i className="ri-bookmark-3-line"></i>
              相关推荐
            </span>
            <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              同类事件也值得对照着看
            </h2>
          </div>
          <Link
            to="/list"
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            更多归档
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((t) => (
            <TopicCard key={t.id} topic={t} />
          ))}
        </div>
      </div>
    </section>
  );
}